import { BaseModel } from "@models/base.model";
import { SearchCriteria } from "@models/searchcriteria.model";

export class Appointment extends BaseModel {
  ProviderId: number;
  PatientId: number;
  RoomId: number;
  EquipmentId: number;
  VisitReasonId: number;
  StatusId: number;
  ServiceLocationId: number = 0;
  Duration: number = 0;
  Notes: string = '';
  AppointmentDate: string = '';
  StartTime: string = '';
  EndTime: string = '';
  AssigneeId: number = 0;
  DOB: any;
  Age: number = 0;
  ClinicalNoteComment: string;
  PatientName: string;
  InsuranceCaseId: number;
  Autharization: string = '';
  InsuranceCompany: string = '';
  RecurringAppointmentId: number = 0;
  RecurringData: RecurringAppointment = new RecurringAppointment();
  CanAppointmentDelete: boolean;
}

export class AppointmentMaster {
  ServiceLocations: Array<any> = [];
  PersonalDetails: Array<any> = [];
  PatientDetails: Array<any> = [];
  Status: Array<any> = [];
  VisitReasons: Array<any> = [];
  Rooms: Array<any> = [];
  Equipments: Array<any> = [];
  Holidays: Array<any> = [];
}

export class AppointmentViewModel {
  Entity = new Appointment();
  Masters = new AppointmentMaster();
}

export class RecurringAppointment extends BaseModel {
  PatternId: number = 1;
  ExcludeSunday: boolean = true;
  ExcludeSaturday: boolean = true;
  ExcludeHoliday: boolean = true;
  Occurance: number = 1;
  AppointmentCount: number = 1;
  WeekConfiguration: string = "";
  EndDate: any;
  StartDate: any;
  IsEdited: boolean;
  Appointments: Array<Appointment>;
  Weeks: Array<Weekdays> = [
    { DayId: 1, DayName: "Sunday", ShortName: "S", RowOrder: 0, IsChecked: false },
    { DayId: 2, DayName: "Monday", ShortName: "M", RowOrder: 100, IsChecked: false },
    { DayId: 3, DayName: "Tuesday", ShortName: "T", RowOrder: 200, IsChecked: false },
    { DayId: 4, DayName: "Wednesday", ShortName: "W", RowOrder: 300, IsChecked: false },
    { DayId: 5, DayName: "Thursday", ShortName: "T", RowOrder: 400, IsChecked: false },
    { DayId: 6, DayName: "Friday", ShortName: "F", RowOrder: 500, IsChecked: false },
    { DayId: 7, DayName: "Saturday", ShortName: "S", RowOrder: 600, IsChecked: false }
  ];
}

export class Weekdays {
  DayId: number;
  DayName: string = '';
  ShortName: string = '';
  RowOrder: number = 0;
  IsChecked: boolean = false;
}

export class AppointmentCriteria extends SearchCriteria {
  Patients: string;
  Providers: string;
  Locations: string;
  VisitTypes :string;
  Status:string;
  StartDate: string;
  EndDate: string;
}


export class AppointmentFilter {
  Patient: Array<any> = [];
  Provider:Array<any> = [];
  Location:Array<any> = [];
  VisitType:Array<any> = [];
  Status:Array<any> = [];
  FromDate: string = "";
  ToDate: string = "";
}